if (!customElements.get('koppa-bestsellers-hero')) {
  customElements.define('koppa-bestsellers-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-video-toggle]');
      this.label = this.querySelector('[data-video-label]');
      this.icon = this.querySelector('.kbh__film-icon');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
      this.video.muted = true;
      this.toggle.hidden = false;
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        this.updatePlayback();
      }, options);
      this.video.addEventListener('playing', () => {
        if (this.userPaused || !this.inView || document.hidden) { this.video.pause(); return; }
        this.video.classList.add('is-ready');
        this.label.textContent = this.toggle.dataset.pause;
        this.icon.textContent = 'Ⅱ';
      }, options);
      this.video.addEventListener('pause', () => {
        this.label.textContent = this.toggle.dataset.play;
        this.icon.textContent = '▶';
      }, options);
      const fail = () => {
        if (!this.video.querySelector('source').hasAttribute('src')) return;
        this.failed = true;
        this.video.classList.remove('is-ready');
        this.toggle.hidden = true;
      };
      this.video.addEventListener('error', fail, options);
      this.video.querySelector('source').addEventListener('error', fail, options);
      this.motion.addEventListener('change', () => {
        this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
        this.updatePlayback();
      }, options);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.updatePlayback();
      }, { threshold: .15 });
      this.visibility.observe(this.querySelector('.kbh__panel--film'));
      const fit = () => {
        const top = this.getBoundingClientRect().top + window.scrollY;
        this.style.setProperty('--kbh-top', `${Math.round(top)}px`);
      };
      this.headerSize = new ResizeObserver(fit);
      document.querySelectorAll('.shopify-section-group-header-group').forEach(header => this.headerSize.observe(header));
      window.addEventListener('resize', fit, options);
      fit();
    }
    updatePlayback() {
      if (this.userPaused || !this.inView || document.hidden || this.failed) { this.video.pause(); return; }
      const source = this.video.querySelector('source');
      if (!source.src) { source.src = source.dataset.src; this.video.load(); }
      this.video.play()?.catch(() => {
        this.label.textContent = this.toggle.dataset.play;
        this.icon.textContent = '▶';
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.visibility?.disconnect();
      this.headerSize?.disconnect();
      this.video?.pause();
    }
  });
}
